export const GoogleAnalytics = {
    initialize(nonce) {
        if (GoogleAnalytics.element) {
            return console.warn('Analytics already initialized');
        }
        GoogleAnalytics.element = true;

        const script = document.createElement('script');
        script.src = 'https://www.googletagmanager.com/gtag/js?id=UA-139864094-7';
        script.async = true;
        if (nonce) script.nonce = nonce;
        document.head.appendChild(script);

        const script2 = document.createElement('script');
        script2.src = 'https://www.googletagmanager.com/gtag/js?id=G-K594J28L5G';
        script2.async = true;
        if (nonce) script2.nonce = nonce;
        document.head.appendChild(script2);

        const code = '(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({\'gtm.start\':\n' +
            '    new Date().getTime(),event:\'gtm.js\'});var f=d.getElementsByTagName(s)[0],\n' +
            '    j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';j.async=true;' +
            '    j.nonce=\'' + nonce + '\';j.src=\n' +
            '    \'https://www.googletagmanager.com/gtm.js?id=\'+i+dl;f.parentNode.insertBefore(j,f);\n' +
            '    })(window,document,\'script\',\'dataLayer\',\'GTM-KP3S87X\');';
        const script3 = document.createElement('script');
        script3.appendChild(document.createTextNode(code));
        if (nonce) script3.nonce = nonce;
        document.head.appendChild(script3);


        gtag('config', 'UA-139864094-7', {
            'anonymize_ip': true,
        });
        let ssoExtCustomerId = null;
        if (SSOSDK) {
            SSOSDK?.getStorageItem('extCustomerId')
                .then((extCustomerId) => ssoExtCustomerId = extCustomerId)
                .catch(() => null)
                .finally(() => {
                    gtag('js', new Date());
                    window.dataLayer[0].language = this.lang ? this.lang : 'ka';

                    gtag('js', new Date());

                    gtag('config', 'G-K594J28L5G', {
                        'anonymize_ip': true,
                        'ext_customer_id': ssoExtCustomerId,
                    });

                    gtag('config', 'G-FE1Q0NSJCZ', {
                        'anonymize_ip': true,
                        'ext_customer_id': ssoExtCustomerId,
                        'transport_url': 'https://owox.solo.ge/ga4/5749e08d1e0145cb8c880e70b1b5c59e',
                    });

                    gtag('config', 'G-1HVT8FEEPK', {
                        'anonymize_ip': true,
                        'transport_url': 'https://streaming.bi.owox.com/ga4/4c4c346c1723480dba5e204c384c2fb8',
                    });
                });
        }
    },
};


